import routeName from '@/router/constant';
import { guideRoutes } from '@/utils/guideRoutes';

const typeName = '6';
const code = 'A6';
const backPage = routeName.CONTACT_INFO;
export const a6Header = [
    {
        path: `${typeName}-policy-list`,
        name: routeName.A6_SELECT_POLICY,
        component: () => import('@/views/policy/Index.vue'),
        meta: {
            auth: true,
            metaTitle: '給付帳號約定',
            pageTitle: '給付帳號約定',
            backPage,
            code,
            unableBack: true,
        },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.CONTACT_INFO, routeName.FINISH, routeName.TWID_RESULT];
            const guideRoute = guideRoutes(from, whiteList, true);
            next(guideRoute);
        },
    },
];
export const a6Step = [
    {
        path: `${typeName}-set-account`,
        name: routeName.A6_SET_ACCONT,
        component: () => import('@/views/a3/landingPage/Index.vue'),
        meta: {
            auth: true,
            metaTitle: '給付帳號約定',
            pageTitle: '給付帳號約定',
            backPage,
            code,
            isNeedPolicyCard: true,
            unableBack: true,
        },
    },
    {
        path: `${typeName}-confirm`,
        name: routeName.A6_CONFIRM,
        component: () => import('@/views/a3/dataConfirm/Index.vue'),
        meta: {
            auth: true,
            metaTitle: '給付帳號約定',
            pageTitle: '給付帳號約定',
            backPage: routeName.A6_SET_ACCONT,
            code,
            isNeedPolicyCard: true,
            unableBack: true,
        },
    },
    {
        path: `${typeName}-OTP`,
        name: routeName.A6_OTP,
        component: () => import('@/views/otp/Index2.vue'),
        meta: {
            auth: true,
            metaTitle: '動態密碼驗證',
            leaveAlert: true,
            pageTitle: '請輸入動態密碼',
            code,
            backPage,
            unableBack: true,
        },

    },
];
